<template>
  <div class="about-container">
    <div class="about-top">
      <carousel :list="bannerList"/>
    </div>
    <div class="about-main">
      <!--顶部-->
      <manifesto :manifesto-details="aboutInfo"/>
      <!--中间-->
      <performance :manifesto-details="aboutInfo"/>
      <!--咨询-->
      <consulting :manifesto-details="aboutInfo"/>
      <!--合作客户-->
      <customer :list="cooperativeList" />
    </div>
  </div>
</template>

<script setup>
import {getBannerList} from "@/api/apiHome";
import carousel from '@/components/carousel/index.vue'
import {ref} from "vue";
import {getAboutInfo} from "@/api/apiAbout";
import manifesto from './components/manifesto.vue'
import customer from './components/customer.vue'
import performance from './components/performance.vue'
import consulting from './components/consulting.vue'
const bannerList = ref([])
const aboutInfo = ref({})
const cooperativeList = ref([])
const queryBannerList = async () => {
  const {code, data} = await getBannerList(1)
  if (code === 200) {
    bannerList.value = data
  }
}
//查询
const queryAboutInfo = async () => {
  const {code, data} = await getAboutInfo()
  if (code === 200) {
    aboutInfo.value = data
    if (data.cooperativeCustomer) {
      cooperativeList.value = JSON.parse(data.cooperativeCustomer)
    }
  }
}
queryAboutInfo()
queryBannerList()
</script>
<style lang="scss" scoped>

.about-top {
  height: 540px;
  overflow: hidden;
}

.about-main {
  box-sizing: border-box;
}
</style>
